import { createFileRoute } from '@tanstack/react-router'
import MealsRequestsPage from '@/features/meals/meals-requests-page'

export const Route = createFileRoute('/_authenticated/dashboard/meals/requests')({
  component: MealsRequestsPage,
})
